import httpClient from './httpClient';
import appConfig from '../config/appConfig';

const isFormData = (value) =>
  typeof FormData !== 'undefined' && value instanceof FormData;

const stripConfiguredBaseUrl = (url) => {
  if (!url || !/^https?:\/\//i.test(url)) {
    return url;
  }

  const requestUrl = new URL(url);
  const configuredBase = new URL(appConfig.api.baseURL, requestUrl.origin);

  if (
    requestUrl.origin === configuredBase.origin &&
    requestUrl.pathname.startsWith(configuredBase.pathname)
  ) {
    return `${requestUrl.pathname.slice(configuredBase.pathname.length) || '/'}${requestUrl.search}`;
  }

  return url;
};

const makeHeaders = (headers = {}) => {
  const normalized = Object.fromEntries(
    Object.entries(headers).map(([key, value]) => [key.toLowerCase(), value])
  );

  return {
    get: (name) => normalized[String(name).toLowerCase()] ?? null,
    entries: () => Object.entries(normalized)[Symbol.iterator](),
    raw: normalized
  };
};

const makeResponse = (response, ok) => ({
  ok,
  status: response.status,
  statusText: response.statusText,
  headers: makeHeaders(response.headers),
  data: response.data,
  json: async () => response.data,
  text: async () =>
    typeof response.data === 'string' ? response.data : JSON.stringify(response.data),
  blob: async () => response.data
});

export const apiRequest = async (route, options = {}) => {
  const headers = { ...(options.headers || {}) };

  if (isFormData(options.body)) {
    delete headers['Content-Type'];
    delete headers['content-type'];
    // The shared Axios instance defaults to application/json. Without this
    // override Axios serializes FormData as JSON before dispatching it, so DRF
    // receives `image` as a normal value instead of an uploaded file. Axios's
    // browser adapter adds the multipart boundary to this header.
    headers['Content-Type'] = 'multipart/form-data';
  }

  try {
    const response = await httpClient.request({
      url: stripConfiguredBaseUrl(route),
      method: options.method || 'GET',
      headers,
      data: options.body,
      params: options.params,
      responseType: options.responseType,
      signal: options.signal
    });

    return makeResponse(response, true);
  } catch (error) {
    if (error.response) {
      return makeResponse(error.response, false);
    }

    throw error;
  }
};

export default apiRequest;
